import { UserForGridModel } from "./userForGridModel";

export class UserGridModel {
  public users: Array<UserForGridModel>;
  public totalRecordsCount: number;
}